import TurnoverContent from "../content/turnoverContent";
import Layout from "../layout/Layout";

const Turnover = () => {
  return (
    <Layout>
      <TurnoverContent />
    </Layout>
  );
};

export default Turnover;
